import type {JSX} from 'react'

interface DropdownData {
	text: string
	value: string
}

interface DropdownProps {
	className?: string
	disabled?: boolean
	dropdownData: DropdownData[]
	fieldName?: string
	hasValueAsUrl?: boolean
	identifier?: string
	label: string
	showLabel?: boolean
	updateFilterValue: (
		value: string,
		identifier: string,
		hasValueAsUr: boolean
	) => void
	value?: string
}

export const Dropdown = ({
	className = '',
	disabled = false,
	dropdownData,
	fieldName = '',
	hasValueAsUrl = false,
	identifier = '',
	label,
	showLabel = true,
	updateFilterValue,
	value = '',
}: DropdownProps): JSX.Element => (
	<div className={`relative mb-8 ${className}`}>
		<label htmlFor={label}>
			{showLabel ? <span className="label-text top">{label}</span> : null}
			<select
				className="dropdown-blue-icon appearance-none"
				disabled={disabled}
				id={label}
				name={fieldName}
				onChange={(e) => {
					updateFilterValue(e.target.value, identifier, hasValueAsUrl)
				}}
				style={{marginBottom: 0}}
				value={value}
			>
				{dropdownData.map((data) => (
					<option key={data.value + data.text} value={data.value}>
						{data.text}
					</option>
				))}
			</select>
			<svg
				height="46"
				viewBox="0 0 48 48"
				width="46"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect fill="" height="48" rx="24" width="48" />
				<path
					d="M7,10,18.426,21.426,29.853,10Z"
					fill="#fff"
					fillRule="evenodd"
					transform="translate(5.574 10.287)"
				/>
			</svg>
		</label>
	</div>
)
